/* casam-fday30.js — Father's Day 2026: silently pre-apply discount code FDAY30 on eligible carts.
   Companion to the `fathers` seasonal skin (casam-seasonal.js stays COSMETIC; this is the one
   cart-mutating helper, kept separate on purpose). FDAY30 is a marketing-created code-based
   discount (30% off the `gift-sets` collection, runs 06-11→06-23). We apply it via a background
   fetch to /discount/FDAY30 (no navigation — the drawer's own discount box redirects to /cart,
   which we deliberately avoid here), then nudge the cart to re-render so the saving shows.

   Strict guards (all must hold, else no-op):
     - within the campaign window (Jun 15–21 2026, matching the fathers skin override),
     - the cart contains a gift-sets product (the only items FDAY30 discounts),
     - NO discount code is already on the cart (never clobber a customer's own / better code),
     - not already auto-applied this session (idempotent via sessionStorage).
   External asset, no inline HTML (geoblock P0 lesson). Safe to leave installed after the
   window — the date guard no-ops it. Remove with the fathers launch cleanup. */
(function () {
  "use strict";

  var CODE = "FDAY30";
  var WIN_START = new Date(2026, 5, 15, 0, 0, 0, 0);        // Jun 15 2026 (month is 0-based)
  var WIN_END   = new Date(2026, 5, 21, 23, 59, 59, 999);   // Jun 21 2026, end-inclusive
  var SS_KEY = "casam_fday30_applied";

  // gift-sets collection product ids (Casa M Spice Co® Gift Sets, gid 55164010611) — the set
  // FDAY30 actually discounts. Verified 2026-06-15; stable for the 1-week campaign.
  var ELIGIBLE = {
    "1736944844915": 1, "3867732672627": 1, "1626169868403": 1, "5306740375709": 1,
    "8498771067094": 1, "8768899350742": 1, "8775693500630": 1, "8775727349974": 1,
    "8775728562390": 1, "8848797565142": 1, "9113003393238": 1, "9113600196822": 1,
    "9113617793238": 1, "9113628934358": 1, "9113648496854": 1, "9113661669590": 1,
    "9113664880854": 1
  };

  var now = new Date();
  if (now < WIN_START || now > WIN_END) return; // outside the campaign window — do nothing

  function nid(x) { x = String(x == null ? "" : x); var m = x.match(/(\d+)\s*$/); return m ? m[1] : x; }
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function applied() { try { return sessionStorage.getItem(SS_KEY) === "1"; } catch (e) { return false; } }
  function markApplied() { try { sessionStorage.setItem(SS_KEY, "1"); } catch (e) {} }

  // true if the cart already carries ANY discount code / cart-level discount — we don't touch those
  function cartHasDiscount(cart) {
    var codes = cart.discount_codes || [];
    if (codes.some(function (d) { return d && d.code && d.applicable !== false; })) return true;
    var apps = cart.cart_level_discount_applications || [];
    return apps.length > 0;
  }
  function eligible(cart) {
    return (cart.items || []).some(function (l) { return ELIGIBLE[nid(l.product_id)]; });
  }

  function tryApply() {
    if (applied()) return;
    getCart().then(function (cart) {
      if (!cart || !(cart.items || []).length) return;
      if (cartHasDiscount(cart)) return;   // never clobber an existing code
      if (!eligible(cart)) return;         // only on carts with a gift set
      markApplied();                       // set before fetch so rapid cart events can't double-fire
      fetch("/discount/" + CODE, { credentials: "same-origin" })
        .then(function () {
          // re-render the drawer so the 30% shows in the totals
          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(new CustomEvent("cart:updated"));
        })
        .catch(function () {});
    }).catch(function () {});
  }

  var t = null;
  function debounced() { clearTimeout(t); t = setTimeout(tryApply, 400); }
  ["cart:updated", "cart:build", "cart:open", "ajaxProduct:added"].forEach(function (ev) {
    document.addEventListener(ev, debounced);
  });
  if (document.readyState !== "loading") tryApply(); else document.addEventListener("DOMContentLoaded", tryApply);
})();
